import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getAllLeaves, updateLeaveStatus } from "../../api/api";
import SuccessModal from "../../components/SuccessModal";

export default function LeaveDetails() {
  const { id } = useParams();
const navigate = useNavigate();
  const [leave, setLeave] = useState(null);
  const [comment, setComment] = useState("");
  const [actionType, setActionType] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [successOpen, setSuccessOpen] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);
const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchLeave();
  }, []);
  const formatDate = (date) => {

  if (!date) return "-";

  return new Date(date)
    .toLocaleDateString("en-GB")
    .replace(/\//g, "-");
};

  const fetchLeave = async () => {
    const data = await getAllLeaves();
    const found = data.find((l) => l.id === parseInt(id));
    setLeave(found);
  };

  const handleSubmit = async (
  selectedAction = actionType
) => {

  if (loading) return;

  if (
    selectedAction === "rejected" &&
    !comment.trim()
  ) {
    alert(
      "Comment is required"
    );

    return;
  }

  try {

    setLoading(true);

    const updated =
      await updateLeaveStatus(
        leave.id,
        selectedAction,
        selectedAction === "approved"
          ? ""
          : comment
      );

    setLeave({
      ...leave,
      status: updated.status,
      manager_comment:
        selectedAction === "approved"
          ? ""
          : comment,
    });

    setSuccessMsg(
      selectedAction === "approved"
        ? "Leave approved successfully"
        : "Leave rejected successfully"
    );

    setShowModal(false);

    setSuccessOpen(true);

    setComment("");

  } catch (err) {

    console.error(err);

    alert(
      err?.response?.data?.error ||
      "Something went wrong"
    );

  } finally {

    setLoading(false);

  }

};

  const getStatusBadge = (status) => {
    switch (status) {
      case "approved":
        return styles.approved;
      case "rejected":
        return styles.rejected;
      case "pending":
        return styles.pending;
      case "withdrawn":
        return styles.withdrawn;
      default:
        return styles.defaultStatus;
    }
  };

  if (!leave) {
    return <div style={{ padding: 30 }}>Loading...</div>;
  }

  return (
    <div style={styles.container}>
      {/* HEADER */}
<div style={styles.header}>
  <div style={styles.headerLeft}>
    <button
      style={styles.backBtn}
      onClick={() => {
  if (window.history.length > 1) {
    navigate(-1);
  } else {
    navigate("/manager/review");
  }
}}
    >
      ← Back
    </button>

    <h2 style={styles.heading}>Leave Details</h2>
  </div>

  <span
    style={{
      ...styles.statusBadge,
      ...getStatusBadge(leave.status),
    }}
  >
    {leave.status}
  </span>
</div>

      {/* MAIN CARD */}
      <div style={styles.card}>
        {/* USER */}
        <div style={styles.userSection}>
          <div style={styles.avatar}>
            {leave.user_name.charAt(0)}
          </div>

          <div>
            <div style={styles.name}>
              {leave.user_name}
            </div>

            <div style={styles.subText}>
              Employee
            </div>
          </div>
        </div>

        {/* INFO GRID */}
        <div style={styles.grid}>
          <div style={styles.infoBox}>
            <div style={styles.label}>
              From Date
            </div>

            <div style={styles.value}>
             {formatDate(leave.from_date)}
            </div>
          </div>

          <div style={styles.infoBox}>
            <div style={styles.label}>
              To Date
            </div>

            <div style={styles.value}>
            {formatDate(leave.to_date)}
            </div>
          </div>

          <div style={styles.infoBox}>
            <div style={styles.label}>
              Total Days
            </div>

            <div style={styles.value}>
              {leave.days}
            </div>
          </div>

          <div style={styles.infoBox}>
            <div style={styles.label}>
              Leave Type
            </div>

<div style={styles.value}>
  {leave.leave_type_name || leave.leave_type?.name || "-"}
</div>
          </div>
        </div>

        {/* REASON */}
        <div style={styles.section}>
          <div style={styles.sectionTitle}>
            Reason
          </div>

          <div style={styles.reasonBox}>
            {leave.reason}
          </div>
        </div>

        {/* MEDICAL DOCUMENT */}
{(leave.leave_type_name === "Sick Leave" ||
  leave.leave_type?.name === "Sick Leave") &&
  leave.medical_file_url && (
            <div style={styles.section}>
              <div style={styles.sectionTitle}>
                Medical Document
              </div>

              <div style={styles.documentBox}>
                <button
                  style={styles.previewBtn}
                  onClick={() =>
                    setPreviewOpen(true)
                  }
                >
                  Preview PDF
                </button>
              </div>
            </div>
          )}

        {/* MANAGER COMMENT */}
        {leave.manager_comment && (
          <div style={styles.section}>
            <div style={styles.sectionTitle}>
              Manager Comment
            </div>

            <div style={styles.commentBox}>
              {leave.manager_comment}
            </div>
          </div>
        )}

        {/* ACTION BUTTONS */}
{leave.status === "pending" && (
  <div style={styles.actionBar}>

    {/* APPROVE */}
    <button
      style={{
        ...styles.approveBtn,
        opacity:
          loading &&
          actionType === "approved"
            ? 0.7
            : 1,
      }}
      disabled={loading}
  onClick={async () => {

  if (loading) return;

  setActionType(
    "approved"
  );

  await handleSubmit(
    "approved"
  );

}}
    >
      {
        loading &&
        actionType === "approved"
          ? "Approving..."
          : "Approve"
      }
    </button>

    {/* REJECT */}
    <button
      style={{
        ...styles.rejectBtn,
        opacity:
          loading &&
          actionType === "rejected"
            ? 0.7
            : 1,
      }}
      disabled={loading}
      onClick={() => {

  if (loading) return;

  setActionType(
    "rejected"
  );

  setComment("");

  setShowModal(
    true
  );

}}
    >
      {
        loading &&
        actionType === "rejected"
          ? "Rejecting..."
          : "Reject"
      }
    </button>

  </div>
)}
      </div>

      {/* APPROVE / REJECT MODAL */}
      {showModal && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalBox}>
            <h3 style={styles.modalTitle}>
              Add Comment
            </h3>

            <textarea
              placeholder="Write your comment here..."
              value={comment}
              onChange={(e) =>
                setComment(e.target.value)
              }
              style={styles.textarea}
            />

<div style={styles.modalActions}>

  <button
    style={{
      ...styles.cancelBtn,
      opacity:
        loading
          ? 0.5
          : 1,
    }}
    disabled={loading}
    onClick={() =>
      setShowModal(
        false
      )
    }
  >
    Cancel
  </button>

  <button
    style={{
      ...styles.confirmBtn,
      opacity:
        loading
          ? 0.7
          : 1,
    }}
    disabled={loading}
    onClick={() =>
  handleSubmit(
    "rejected"
  )
}
  >
{
  loading
    ? (
        actionType === "approved"
          ? "Approving..."
          : "Rejecting..."
      )
        : (
            actionType === "approved"
              ? "Approve"
              : "Reject"
          )
    }
  </button>

</div>
          </div>
        </div>
      )}

      {/* PDF PREVIEW MODAL */}
      {previewOpen && (
        <div style={styles.pdfOverlay}>
          <div style={styles.pdfModal}>
            <div style={styles.pdfHeader}>
              <h3 style={styles.pdfTitle}>
                Medical Document
              </h3>

              <button
                style={styles.closeBtn}
                onClick={() =>
                  setPreviewOpen(false)
                }
              >
                ✕
              </button>
            </div>

            <iframe
              src={leave.medical_file_url}
              title="Medical PDF"
              style={styles.pdfFrame}
            />
          </div>
        </div>
      )}

      <SuccessModal
  open={successOpen}
  message={successMsg}
  onClose={() => {

    setSuccessOpen(
      false
    );

    navigate(
      "/manager/review"
    );

  }}
/>
    </div>
  );
}

/* ================= STYLES ================= */

const styles = {
  container: {
  padding: window.innerWidth < 768 ? "14px" : "25px",
  background: "#f4f6f9",
  minHeight: "100vh",
  fontFamily: "'Inter', sans-serif",
},

  header: {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "10px",
  marginBottom: "18px",
  flexWrap: "nowrap",
},

 heading: {
  fontSize: window.innerWidth < 768 ? "18px" : "30px",
  fontWeight: "700",
  color: "#111827",
  margin: 0,
  whiteSpace: "nowrap",
},

  card: {
  background: "#fff",
  borderRadius: window.innerWidth < 768 ? "18px" : "24px",
  padding: window.innerWidth < 768 ? "16px" : "26px",
  boxShadow: "0 10px 30px rgba(15,23,42,0.05)",
  border: "1px solid #edf2f7",
},

  userSection: {
  display: "flex",
  alignItems: "center",
  gap: "12px",
  marginBottom: "20px",
  flexWrap: "wrap",
},

  avatar: {
  width: window.innerWidth < 768 ? "42px" : "52px",
  height: window.innerWidth < 768 ? "42px" : "52px",
  borderRadius: "50%",
  background: "#2563eb",
  color: "#fff",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: "700",
  fontSize: window.innerWidth < 768 ? "15px" : "18px",
},

  name: {
    fontSize: "16px",
    fontWeight: "600",
  },

  subText: {
    fontSize: "13px",
    color: "#777",
  },

  grid: {
  display: "grid",
  gridTemplateColumns:
    window.innerWidth < 768
      ? "1fr"
      : "repeat(auto-fit,minmax(220px,1fr))",
  gap: "15px",
  marginBottom: "20px",
},

  infoBox: {
  background: "#f8fbff",
  padding: window.innerWidth < 768 ? "14px" : "18px",
  borderRadius: "16px",
  border: "1px solid #e2e8f0",
},

  label: {
  fontSize: window.innerWidth < 768 ? "11px" : "12px",
  color: "#64748b",
  fontWeight: "600",
},

  value: {
  fontSize: window.innerWidth < 768 ? "14px" : "16px",
  fontWeight: "700",
  marginTop: "6px",
  color: "#111827",
  wordBreak: "break-word",
},

  section: {
    marginTop: "20px",
  },

  sectionTitle: {
    fontWeight: "600",
    marginBottom: "8px",
  },

  reasonBox: {
    background: "#fafafa",
    padding: "12px",
    borderRadius: "6px",
    border: "1px solid #eee",
  },

  commentBox: {
    background: "#eef6ff",
    padding: "12px",
    borderRadius: "6px",
    border: "1px solid #cfe3ff",
  },

actionBar: {
  marginTop: "25px",
  display: "flex",
  gap: "12px",
  flexWrap: "wrap",
},

  approveBtn: {
  background: "#16a34a",
  color: "#fff",
  padding: window.innerWidth < 768 ? "10px 14px" : "12px 20px",
  border: "none",
  borderRadius: "12px",
  cursor: "pointer",
  fontWeight: "600",
  flex: window.innerWidth < 768 ? 1 : "unset",
},

  rejectBtn: {
  background: "#dc2626",
  color: "#fff",
  padding: window.innerWidth < 768 ? "10px 14px" : "12px 20px",
  border: "none",
  borderRadius: "12px",
  cursor: "pointer",
  fontWeight: "600",
  flex: window.innerWidth < 768 ? 1 : "unset",
},

  statusBadge: {
  padding: window.innerWidth < 768 ? "5px 10px" : "6px 14px",
  borderRadius: "999px",
  fontSize: window.innerWidth < 768 ? "11px" : "13px",
  fontWeight: "600",
  textTransform: "capitalize",
  whiteSpace: "nowrap",
},

  approved: {
    background: "#2e7d32",
    color: "#fff",
  },

  rejected: {
    background: "#d32f2f",
    color: "#fff",
  },

  pending: {
    background: "#ed6c02",
    color: "#fff",
  },

  withdrawn: {
    background: "#6d4c41",
    color: "#fff",
  },

  defaultStatus: {
    background: "#616161",
    color: "#fff",
  },

  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "rgba(0,0,0,0.4)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 999,
  },

  modalBox: {
  background: "#fff",
  padding: window.innerWidth < 768 ? "16px" : "22px",
  borderRadius: "18px",
  width: window.innerWidth < 768 ? "92%" : "420px",
  maxWidth: "420px",
},

  modalTitle: {
    fontSize: "18px",
    marginBottom: "10px",
  },

  textarea: {
    width: "100%",
boxSizing: "border-box",
    minHeight: "110px",
    padding: "12px 14px",
    borderRadius: "8px",
    border: "1px solid #dcdfe4",
    fontSize: "14px",
    outline: "none",
    background: "#fafafa",
    resize: "none",
  },

  modalActions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    marginTop: "15px",
  },

  cancelBtn: {
    background: "#eee",
    border: "none",
    padding: "8px 14px",
    cursor: "pointer",
  },

  confirmBtn: {
    background: "#1976d2",
    color: "#fff",
    border: "none",
    padding: "8px 14px",
    cursor: "pointer",
  },

  documentBox: {
    background: "#fafafa",
    padding: "14px",
    borderRadius: "8px",
    border: "1px solid #eee",
  },

  previewBtn: {
    background: "#1976d2",
    color: "#fff",
    border: "none",
    padding: "10px 18px",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "500",
  },

  pdfOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "rgba(0,0,0,0.7)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },

  pdfModal: {
  width: window.innerWidth < 768 ? "96%" : "85%",
  height: window.innerWidth < 768 ? "92%" : "90%",
  background: "#fff",
  borderRadius: window.innerWidth < 768 ? "16px" : "20px",
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
},

  pdfHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "14px 18px",
    borderBottom: "1px solid #eee",
  },

  pdfTitle: {
    margin: 0,
    fontSize: "18px",
    fontWeight: "600",
  },

  closeBtn: {
    background: "transparent",
    border: "none",
    fontSize: "22px",
    cursor: "pointer",
  },

  pdfFrame: {
    flex: 1,
    width: "100%",
    border: "none",
  },
  headerLeft: {
  display: "flex",
  alignItems: "center",
  gap: window.innerWidth < 768 ? "8px" : "12px",
  minWidth: 0,
},
backBtn: {
  background: "#fff",
  border: "1px solid #dbeafe",
  color: "#2563eb",
  padding: window.innerWidth < 768 ? "6px 10px" : "10px 16px",
  borderRadius: "10px",
  cursor: "pointer",
  fontWeight: "600",
  fontSize: window.innerWidth < 768 ? "12px" : "14px",
  boxShadow: "0 4px 12px rgba(15,23,42,0.05)",
  whiteSpace: "nowrap",
},
};